import React from 'react';
import { Card, CardTitle } from 'reactstrap';
import { Field } from '@availity/form';
//import { PriceBadge } from '@/components'; some future options may have a price

const QualityCard: React.FC = () => {
  // const { network } = useNetwork();
  return (
    <Card body className="mb-3 h-100">
      <CardTitle tag="h4" className="lead text-uppercase">
        Quality
      </CardTitle>
      <Field
        type="checkbox"
        name="enhanceProfile"
        label="Add Enhanced Data"
        value="enhanceProfile"
      />

      <Field
        type="checkbox"
        name="rejectDisconnected"
        label="Reject Disconnected"
        value="rejectDisconnected"
      />

      <Field
        type="checkbox"
        name="rejectDNC"
        label="Reject DNC"
        value="rejectDNC"
      />
    </Card>
  );
};

export default QualityCard;
